module Meevo.Plugins.ReportingHierarchy {
    "use strict";

    /**
     * Main Section of Client
     */

    import IReportingHierarchyBranch = Meevo.Model.IReportingHierarchyBranch;

    export class DesignHierarchySection extends BaseSection {

        nodes: IReportingHierarchyBranch[] = [];
        nodesBackup: IReportingHierarchyBranch[] = [];

        tree: IReportingHierarchyBranch[] = [];
        nodesById: {
            [key: string]: IReportingHierarchyBranch
        }

        treeOptions: any = {
            maxDepth: 4,
            beforeDrag (source) {
                return source.node.parent !== null;
            },
            accept (source, dest, index) {

                if (dest.depth() >= this.maxDepth)
                    return false;

                if (!angular.isDefined(dest.node))
                    return false;

                if (angular.isDefined(this.locationsByNode[dest.node.id]) && this.locationsByNode[dest.node.id].length > 0) {
                    return false;
                }

                return true;
            },
            dropped (e) {
                e.source.nodeScope.$modelValue.parent = e.dest.nodesScope.$parent.node.id;
            }
        };

        modalService: Meevo.Components.Modal.IModalService;

        constructor(params) {
            super(params);

            this.modalService = params.modalService;
        }

        activate() {
            super.activate();

            this.fetchBranches()
                .then(() => this.populate());
        }

        validate() {
            let errors = [];

            return errors
                .concat(this.validateNames());
        }

        validateNames(): any[] {
            const self = this;
            let uniqueNames = [];

            let nonUniqueName;

            const valid = !this.tree.some(function getUnique(node) {
                if (uniqueNames.indexOf(node.displayName.toLowerCase()) > -1) {
                    nonUniqueName = node.displayName;
                    return true;
                } else {
                    uniqueNames.push(node.displayName.toLowerCase());
                }

                if (node.nodes.length > 0) {
                    return node.nodes.some(getUnique);
                }

                return false;
            });

            if (!valid) {
                return [{
                    message: `Validation failed:-- Tier name must be unique. Item with the name '${nonUniqueName}' exists in this hierarchy`
                }]
            }

            return [];
        }

        takeNodesBackup() {
            this.nodesBackup = angular.copy(this.serializeBranches());
        }

        rollbackChanges() {
            this.nodes = angular.copy(this.nodesBackup);

            super.rollbackChanges();

            this.populate();
        }

        fetchBranches() {
            this.loadingInProgress = true;
            return this.dataService.getItem(`${this.baseEndpoint}Tree/${this.model.id}`)
                .then((res: any) => {
                    this.nodes = res.branches;
                    this.nodesBackup = angular.copy(this.nodes);
                })
                .finally(() => {
                    this.loadingInProgress = false;
                });
        }

        populate() {
            if (this.nodes.length === 0) {
                this.nodes.push(this.createNode({ displayName: this.model['displayName'] }));
            }

            this.tree = this.nodes.map((node): IReportingHierarchyBranch => {
                node.nodes = this.nodes.filter(n => n.parentBranch_TId === node.branch_TId);
                return node;
            }).filter(node => {
                return !angular.isDefined(node.parentBranch_TId) || node.parentBranch_TId === null
            });

            this.setNodesLookup();
        }

        createNode(data?): IReportingHierarchyBranch {
            const { branch_TId = NewGuid(), displayName = '', parentBranch_TId = null } = data;

            const node = {
                branch_TId,
                displayName,
                siblingSequenceId: 1,
                hasNodes: false,
                nodes: [],
                parentBranch_TId
            } as IReportingHierarchyBranch

            return node;
        }

        setNodesLookup() {
            var self = this;
            this.nodesById = {};
            this.tree.forEach(function setNodeById(node) {
                self.nodesById[node.branch_TId] = node;
                if (node.nodes) {
                    node.nodes.forEach(setNodeById);
                }
            });
        }

        addNode(node) {

            const newNode = this.createNode({
                parentBranch_TId: node.branch_TId
            });

            if (node.hasNodes || node.hasPendingNodes) {
                this.modalService.alert('This branch has locations assigned to it. They will be moved to new branch');
                newNode.hasPendingNodes = true
            }

            node.nodes.push(newNode);

            this.setNodesLookup();

        }

        removeNode(node: IReportingHierarchyBranch) {

            if ([node].some(function someHasNodes(n) {
                return n.hasNodes || n.nodes.some(someHasNodes);
            })) {
                this.modalService.warning('This group cannot be deleted. Please remove all associated locations.');
            } else {
                var parent = this.nodesById[node.parentBranch_TId];
                parent.nodes = parent.nodes.filter(n => n.branch_TId !== node.branch_TId);
            }

        }

        public serialize() {
            return {
                id: this.model.id,
                entityVersion: this.model.entityVersion,
                branches: this.serializeBranches()
            }
        }

        public serializeBranches() {
            const branches = [];
            this.tree.forEach(function getNode(node, index) {
                const {branch_TId, displayName, parentBranch_TId} = node;

                const serialized: any = {
                    branch_TId,
                    displayName,
                    siblingSequenceId: index + 1,
                    isBottom: !node.nodes || node.nodes.length === 0
                }

                if (parentBranch_TId !== null) {
                    serialized.parentBranch_TId = parentBranch_TId;
                };

                if (node.nodes) {
                    node.nodes.forEach(getNode);
                }

                branches.push(serialized);
            });
            return branches;
        }



    }
}
